import { Injectable } from '@angular/core';
import { BecareService } from './becare.service';
import { CNContactRXSerie } from '../models/cncontactrxserie';
import { CNPatient } from '../models/cnpatient';
import { CNConsultation } from '../models/cnconsultation';
import { Observable } from 'rxjs';
import { SNItemFactory } from '../models/snitemfactory';

@Injectable({
  providedIn: 'root'
})
export class ImagingService {

  constructor(private becare: BecareService) {
    
  }

  rxSerieImages(patient: CNPatient, contact: CNConsultation, serie: CNContactRXSerie): Observable<CNContactRXSerie> {
    // tslint:disable-next-line:max-line-length
    return new Observable(observer => {
      this.becare.call('/fr/patient/' + patient.id + '/contact/' + contact.id + '/rx/serie/' + serie.id).subscribe(result => {
        if (result.success) {
          const factory = new SNItemFactory();
          observer.next(factory.itemFromJson(result.serie));
        } else {
          observer.error('failed to store consultation');
        }
      });
    });
  }

  sendToPacs(serie: CNContactRXSerie): Observable<string[]> {
    return new Observable(observer => {
      this.becare.call('/fr/rx/serie/' + serie.id + '/webpacs', [], undefined, 'post').subscribe(result => {
        if (result.success) {
          observer.next(result.studies);
        } else {
          observer.error('failed to store series to pacs');
        }
      }, error => {
        observer.error('failed to store series to pacs');
      });
    });
  }
}
